import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayL, LabelM } from '@sorare/core/src/atoms/typography';

import { Step } from 'components/rewards/BoxOpeningOnboardingDialog/CardOpeningOnboardingDialog/Step';

import { SerialNumber_anyCard } from './__generated__/index.graphql';

type Props = { card: SerialNumber_anyCard; serialNumber: number };
export const SerialNumber = ({ card, serialNumber }: Props) => {
  return (
    <Step
      card={card}
      badge={
        <LabelM color="var(--c-rivals-friendlies)" bold>
          {serialNumber}/1000
        </LabelM>
      }
      color="#00fff7"
      description={
        <Vertical gap={0.5}>
          <FormattedMessage
            id="BoxOpeningOnboardingDialog.serialNumberStep.descriptionWithSerialNumber"
            defaultMessage="<xs>Digital Collectible</xs><xl>Edition {br}{serialNumber}/1000</xl><md>Collect and trade cards with other managers around the world.</md>"
            values={{
              br: <br />,
              xs: content => <LabelM>{content}</LabelM>,
              xl: content => (
                <DisplayL color="var(--c-rivals-friendlies)">
                  {content}
                </DisplayL>
              ),
              md: content => <LabelM>{content}</LabelM>,
              serialNumber,
            }}
          />
        </Vertical>
      }
    />
  );
};

SerialNumber.fragments = {
  anyCard: gql`
    fragment SerialNumber_anyCard on AnyCardInterface {
      slug
      ...Step_anyCard
    }
    ${Step.fragments.anyCard}
  ` as TypedDocumentNode<SerialNumber_anyCard>,
};
